(function (){
    'use strict';

    angular
        .module('services')
        .service('AreaService', AreaService);

    AreaService.$inject = ['$http', 'API_BASE'];

    function AreaService ($http, API_BASE) {
        var service = this;


        service.getAll  = getAll;

        function getAll () {
            return $http.get(API_BASE + '/areas');
        }

    }
})();